import React, { Component } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Paginator from '../../../../../components/Paginator';
import { sortUrl, parse, toSortOrder } from '../../../../../utils/UrlUtil';
import TableHeader from './ImportDefinitionListHeader';

const messages = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'name' },
  email: { id: 'attrs.email', defaultMessage: 'Email' },
  comments: { id: 'attrs.comments', defaultMessage: 'Comments' },
});

const commentsEnableTemplate = rowData => (rowData.commentsEnabled ? (
  <FormattedMessage id="lbl.yes" defaultMessage="Yes" />
) : (
  <FormattedMessage id="lbl.no" defaultMessage="No" />
));

const nameTemplate = (rowData, { currentAccount, keyField, displayField }) => {
  const detailUrl = `/accounts/${currentAccount}/surveys/${rowData[keyField]}`;
  return (
    <Link to={detailUrl} className="app-link">
      {rowData[displayField]}
    </Link>
  );
};

class ImportDefinitionList extends Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(event) {
    const { location, history } = this.props;
    sortUrl(event, location, history);
  }

  render() {
    const {
      connection: {
        edges, totalCount, indexFrom, indexTo, pageInfo,
      },
      intl: { formatMessage },
      currentAccount,
      loading,
      location,
    } = this.props;
    // data list
    const listRows = edges.map(({ node }) => ({
      ...node,
    }));

    const params = parse(location.search);
    const { sort = {} } = params;
    const { sortBy, sortDir } = sort;

    // header
    const nameHeader = formatMessage(messages.name);
    const emailHeader = formatMessage(messages.email);
    const commentEnableHeader = formatMessage(messages.comments);

    // footer
    const footer = <Paginator totalCount={totalCount} indexFrom={indexFrom} indexTo={indexTo} pageInfo={pageInfo} />;

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <TableHeader />
        </div>
        <div className="p-col-12">
          <DataTable
            value={listRows}
            footer={footer}
            responsive
            sortField={sortBy}
            sortOrder={toSortOrder(sortDir)}
            onSort={this.onSortChange}
            lazy
            loading={loading}
          >
            <Column
              field="name"
              header={nameHeader}
              body={nameTemplate}
              keyField="id"
              displayField="name"
              currentAccount={currentAccount}
              sortable
            />
            <Column field="selfEmail" header={emailHeader} />
            <Column field="commentsEnabled" header={commentEnableHeader} body={commentsEnableTemplate} />
          </DataTable>
        </div>
      </div>
    );
  }
}

ImportDefinitionList.propTypes = {
  connection: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(injectIntl(ImportDefinitionList));
